const ready = new Map();
const queued = new Map();
const inflight = new Set();
const MAX_INFLIGHT = 3;

function loadBitmap(src, priority) {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.decoding = "async";
    try {
      img.fetchPriority = priority;
    } catch {
      /* older browsers */
    }
    img.onload = () => {
      const finish = () => resolve(src);
      if (img.decode) {
        img.decode().then(finish).catch(finish);
      } else {
        finish();
      }
    };
    img.onerror = reject;
    img.src = src;
  });
}

function pump() {
  if (inflight.size >= MAX_INFLIGHT) return;
  const next = [...queued.values()].sort((a, b) => a.rank - b.rank)[0];
  if (!next) return;
  queued.delete(next.src);
  inflight.add(next.src);
  const job = loadBitmap(next.src, next.rank < 3 ? "high" : "low")
    .catch(() => next.src)
    .finally(() => {
      inflight.delete(next.src);
      pump();
    });
  ready.set(next.src, job);
  pump();
}

export function warmSrc(src, rank = 6) {
  if (!src) return Promise.resolve(src);
  if (ready.has(src)) return ready.get(src);
  const prev = queued.get(src);
  if (!prev || rank < prev.rank) {
    queued.set(src, { src, rank });
  }
  pump();
  return ready.get(src) || Promise.resolve(src);
}

export function warmAround(urls, index, extra = []) {
  if (!urls?.length) return;
  const order = [index, index + 1, index - 1, index + 2, index - 2, ...extra];
  order.forEach((i, rank) => {
    if (i < 0 || i >= urls.length) return;
    warmSrc(urls[i], rank);
  });
}

export function warmList(urls, startRank = 8) {
  (urls || []).forEach((src, i) => warmSrc(src, startRank + i));
}

export function whenIdle(fn) {
  const start = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 180));
  const stop = window.cancelIdleCallback || window.clearTimeout;
  const id = start(() => fn());
  return () => stop(id);
}
